// libs
import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { AddBlock } from '@lyearn/molecules';
import { cn } from '@lyearn/style';
// components
import { Box, Loader, Stack } from '@lyearn/ui';
import * as ContentList from '@/components/ContentList';
import { FilterOption } from '@/components/Filter/types';
import { Filter } from '@/components/FilterManager';

import useLearningContent from '../../hooks/useLearningContent';
// types
import ListItem from '../ContentItemContainer';
import { AddBlockStyles, MENU_LIST_OVERRIDES } from '../RelatedSkillsOrMindsets/style';
import { renderContentItem } from './utils';

function LearningContent({
  onChange,
  value,
}: {
  onChange: (ids: string[]) => void;
  value: string[];
}) {
  const { t } = useTranslation();
  const {
    isFetching,
    selectedContentsState,
    onContentDelete,
    search,
    setSearch,
    fetchMore,
    open,
    filterGroups,
    toggle,
    onContentChange,
  } = useLearningContent({
    contentIds: value,
    onChange,
  });

  return (
    <Box className="w-full">
      <ContentList.Provider
        className={cn('w-full space-y-20', selectedContentsState?.length ? 'mb-16 mt-4' : '')}
        items={selectedContentsState}>
        {isFetching ? (
          <Stack alignItems="center" className="flex-1" justifyContent="center">
            <Loader />
          </Stack>
        ) : (
          <ContentList.Items
            renderer={(index) => {
              const currentContent = selectedContentsState?.[index];

              if (!currentContent || !value.includes(currentContent.id)) {
                return null;
              }

              return (
                <ListItem
                  key={currentContent.id}
                  content={currentContent}
                  onDelete={onContentDelete}
                />
              );
            }}
          />
        )}
      </ContentList.Provider>
      <Filter
        asyncOptions={{
          search: {
            value: search,
            onChange: setSearch,
          },
          fetchMore,
        }}
        groups={filterGroups}
        itemRenderer={renderContentItem}
        open={open}
        overrides={MENU_LIST_OVERRIDES}
        showActionButtons={false}
        value={(selectedContentsState || []) as FilterOption[]}
        onChange={onContentChange}
        onClose={toggle}
        onToggle={toggle}>
        <AddBlock className={AddBlockStyles} title={t('Feedback:CreateFeedback.AddContent')} />
      </Filter>
    </Box>
  );
}

export default LearningContent;
